<template>
    <div class="min-h-screen flex bg-gradient-to-br from-red-500 via-red-400 to-white">
      <!-- Left Side - Company Info -->
      <div class="hidden lg:flex lg:w-1/2 flex-col justify-center items-center p-12 text-white relative overflow-hidden">
        <!-- Background overlay for better text readability -->
        <div class="absolute inset-0 bg-black bg-opacity-20"></div>
        
        <div class="relative z-10 text-center max-w-lg">
          <h1 class="text-5xl font-bold mb-6 leading-tight">
            Cash<span class="text-red-100">Request</span>
          </h1>
          
          <div class="w-24 h-1 bg-white mx-auto mb-8 rounded-full"></div>
          
          <p class="text-xl mb-8 leading-relaxed text-red-50">
            Take control of your financial future with our comprehensive cash flow management platform.
          </p>
          
          <div class="space-y-4 text-left ml-10 mb-20">
            <div class="flex items-center space-x-3">
              <div class="w-2 h-2 bg-white rounded-full"></div>
              <span class="text-red-100">Real-time financial tracking</span>
            </div>
            <div class="flex items-center space-x-3">
              <div class="w-2 h-2 bg-white rounded-full"></div>
              <span class="text-red-100">Advanced analytics & insights</span>
            </div>
            <div class="flex items-center space-x-3">
              <div class="w-2 h-2 bg-white rounded-full"></div>
              <span class="text-red-100">Secure & reliable platform</span>
            </div>
          </div>
          
          <div class="text-sm text-red-100">
            © 2025 MAICO LTD
          </div>
        </div>
      </div>
  
      <!-- Right Side - Login Form -->
      <div class="w-full lg:w-1/2 flex items-center justify-center p-8">
        <div class="bg-white bg-opacity-95 backdrop-blur-lg p-10 rounded-2xl shadow-2xl w-full max-w-md border border-white border-opacity-20">
          <!-- Mobile company name -->
          <div class="lg:hidden text-center mb-8">
            <h1 class="text-3xl font-bold text-red-600">Maico Cash Request</h1>
            <p class="text-gray-600 mt-2">Financial Management Platform</p>
          </div>
  
          <div class="text-center mb-8">
            <h2 class="text-2xl font-bold text-gray-800 mb-2">Welcome Back</h2>
            <p class="text-gray-600">Sign in to your account</p>
          </div>
  
          <form @submit.prevent="login" class="space-y-6">
            <div>
              <label for="email" class="block text-sm font-medium text-gray-700 mb-2">
                Email Address
              </label>
              <input
                id="email"
                v-model="email"
                type="email"
                required
                placeholder="Enter your email"
                class="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500 transition-colors duration-200 bg-white bg-opacity-80"
              />
            </div>
  
            <div>
              <label for="password" class="block text-sm font-medium text-gray-700 mb-2">
                Password
              </label>
              <input
                id="password"
                v-model="password"
                type="password"
                required
                placeholder="Enter your password"
                class="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500 transition-colors duration-200 bg-white bg-opacity-80"
              />
            </div>
  

  
            <button
              type="submit"
              class="w-full bg-gradient-to-r from-red-600 to-red-700 text-white p-3 rounded-lg hover:from-red-700 hover:to-red-800 focus:ring-2 focus:ring-red-300 transition-all duration-200 font-semibold shadow-lg"
            >
              Sign In
            </button>
          </form>

          <!-- Privacy Policy Link -->
          <div class="mt-6 text-center">
            <router-link
              to="/privacy-policy"
              class="text-sm text-gray-600 hover:text-red-600 transition-colors duration-200"
            >
              Privacy Policy
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  
  export default {
    data() {
      return { 
        email: '', 
        password: '' 
      };
    },
    methods: {
      async login() {
        try {
          const res = await axios.post('https://guarantee.iwacufinance.com/cash-request/api/auth/login', {
            email: this.email,
            password: this.password,
          });
          
          // Note: localStorage usage here - you may want to replace with Vuex/Pinia
          // or session-based state management for better security
          localStorage.setItem('token', res.data.token);
          localStorage.setItem('user', JSON.stringify(res.data.user));
          
          this.$router.push({ name: 'Dashboard' });
        } catch (error) {
          alert('Login failed: ' + error.response?.data?.message || error.message);
        }
      }
    },
  };
  </script>